export default (props: { fill: string }) => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		style={{ minWidth: "fit-content" }}
		fill={props.fill}
		xmlns="http://www.w3.org/2000/svg"
	>
		<path d="M13 5H11V9H7V11H11V15H13V11H17V9H13V5Z" fill={props.fill} />
		<line x1="7" y1="18" x2="17" y2="18" stroke={props.fill} strokeWidth="2" />
	</svg>
);
